import React from 'react';
import _merge from 'lodash/merge';
import { getContext, useCombinedRefs } from 'common';
import styled from './styles';

export interface StatusBarPaginationInputProps extends React.ComponentPropsWithRef<'div'> {
  /** Value of input. */
  value?: number | string;
  /** onClick callback */
  onClick?: React.MouseEventHandler;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/**
 * StatusBarPaginationInput component. This component is the wrapper of input used in pagination.
 * All otherProps than value will be provided to the root element
 */
const StatusBarPaginationInput = React.forwardRef<HTMLElement, StatusBarPaginationInputProps>((props: StatusBarPaginationInputProps, ref) =>
  getContext(({ RTL, theme }: { theme?: any, RTL: boolean }) => {
    const {
      value,
      onClick,
      theme: propTheme,
      ...otherProps
    } = props;
    const inputRef = React.useRef(null);
    const combinedRef = useCombinedRefs(ref, inputRef);
    const resolvedTheme = _merge({}, theme.STATUSBAR, propTheme);
    const handleClick = (event) => {
      event.target.select();
      onClick && onClick(event);
    };
    // Make input width auto-growing with value
    React.useEffect(() => {
      combinedRef.current.style.width = `${combinedRef.current.value.length + 1}ch`;
    }, [value, combinedRef.current]);
    return (
      <styled.StatusBarPaginationInput
        ref={combinedRef}
        $rtl={RTL}
        $theme={resolvedTheme}
        value={value}
        onClick={handleClick}
        {...otherProps}
      />
    );
  }));

StatusBarPaginationInput.displayName = 'StatusBarPaginationInput';

StatusBarPaginationInput.defaultProps = {
  value: 0,
  onClick: undefined,
  theme: {}
};
export default StatusBarPaginationInput;
